import { useMediaQuery } from 'react-responsive';

import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import Jumbotron from '@/components/ui/box/Jumbotron';
import Panel from '@/components/ui/box/Panel';
import Paper from '@/components/ui/box/Paper';
import Button from '@/components/ui/buttons/Button';
import { pageTitles } from '@/constants/pageTitles';
import AccountRegistrationConfirmation from '@/features/registration/components/AccountRegistrationConfirmation';
import {
  type AccountRegistrationFormValues,
  type StudentInfo,
} from '@/interfaces/registration';

import CSSModule from './AccountRegistrationConfirmationPage.module.scss';

interface Props {
  formValues: AccountRegistrationFormValues;
  studentInfo: StudentInfo;
  onBack: () => void;
  resendErrorStatus?: number;
  onClickAccountRegistration: () => void;
}

const AccountRegistrationConfirmationPage: React.FC<Props> = ({
  formValues,
  studentInfo,
  onBack,
  resendErrorStatus,
  onClickAccountRegistration,
}) => {
  const isPC = useMediaQuery({ query: '(min-width: 640px)' });

  return (
    <SingleColumnTemplate>
      <div className={CSSModule.AccountRegistrationConfirmationPage}>
        <Jumbotron>
          <Paper>
            <Panel
              title={pageTitles.accountRegistrationConfirmation}
              strongHeader
            >
              <div
                className={CSSModule.AccountRegistrationConfirmationPage__Title}
              >
                以下の内容でアカウントの仮登録を行います。詳細をご確認ください。
              </div>
              <AccountRegistrationConfirmation
                formValues={formValues}
                studentInfo={studentInfo}
                isPC={isPC}
                resendErrorStatus={resendErrorStatus}
                onClickAccountRegistration={onClickAccountRegistration}
              />
              <Button
                className={
                  CSSModule.AccountRegistrationConfirmationPage__GoBackButton
                }
                color="link"
                size={isPC ? 'l' : 'm'}
                onClick={onBack}
              >
                &lt; 戻る
              </Button>
            </Panel>
          </Paper>
        </Jumbotron>
      </div>
    </SingleColumnTemplate>
  );
};

export default AccountRegistrationConfirmationPage;
